const config = require('./configuration').conf;

const environment = process.env.NODE_ENV || "development";

const globConfig = config[environment];


export default globConfig;